import { Feature, UserSetting } from 'src/WebApiController';

import { useUserHasFeature } from './useUserHasFeature';
import { useServerUserSetting } from './useUserSetting';

export const useEnableSelectionByDefault = () => {
  const hasEnableSelectionByDefaultSettingFeature = useUserHasFeature(
    Feature.EnableSelectionByDefaultSetting
  );

  const { value: settingEnabled } = useServerUserSetting<boolean>({
    id: UserSetting.EnableSelectionByDefault,
  });

  // Requires both setting and feature flag to be enabled
  // If there's no feature flag, then user has no access to the setting, so should be set to false
  return Boolean(hasEnableSelectionByDefaultSettingFeature && settingEnabled);
};
